// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZNJz","label":"styles_label__3aohP"};